import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

// ReactDOM.render(<App />, document.getElementById('productDesignerRoot'));


document.addEventListener("DOMContentLoaded", function(){
    const designerRoots = document.querySelectorAll('.productDesignerRoot');

    for (var index = 0; index < designerRoots.length; index++) {
        let designerHasComplex = false;
        let designerHasSimple = false;
        let designerArticleId = '';
        let designerLoadedDesign = null;
        let designerMode = null;
        let renderMode = 'designer';
        let exportScaling = 1;
        let submitMode = 'basket';
        let exportPerspective = null;
        let exportBorder = false;
        let showDebug = false;
        let designerLoadedCallback = null;
        let designerSelectedSize = null;
        let designerSelectedColor = null;
        let isDesignerAddonMode = null;
        let addonArticleName = '';
        let addonBasketArticleId = '';
        let designerConfigInterfaceUrl = 'https://www.hundeshop.de/index.php?cl=tspdDetails_ProductDesigner&fnc=getDesignerConfigJSON&aid=';

        const rootEl = designerRoots.item(index);

        if (rootEl !== null )
        {
            if (rootEl.getAttribute('data-jsonurl') !== null && rootEl.getAttribute('data-jsonurl') !== undefined)
                designerConfigInterfaceUrl = rootEl.getAttribute('data-jsonurl');

            if (rootEl.getAttribute('data-addon-articlename') !== null && rootEl.getAttribute('data-addon-articlename') !== undefined)
                addonArticleName = rootEl.getAttribute('data-addon-articlename');

            if (rootEl.getAttribute('data-for-basketartid') !== null && rootEl.getAttribute('data-for-basketartid') !== undefined)
                addonBasketArticleId = rootEl.getAttribute('data-for-basketartid');

            if (rootEl.getAttribute('data-iscomplex') !== null && rootEl.getAttribute('data-iscomplex') !== undefined)
                designerHasComplex = (rootEl.getAttribute('data-iscomplex') == '1');

            if (rootEl.getAttribute('data-issimple') !== null && rootEl.getAttribute('data-issimple') !== undefined)
                designerHasSimple = (rootEl.getAttribute('data-issimple') == '1');

            if (rootEl.getAttribute('data-designerarticleid') !== null && rootEl.getAttribute('data-designerarticleid') !== undefined)
                designerArticleId = rootEl.getAttribute('data-designerarticleid');

            if (rootEl.getAttribute('data-rendermode') !== null && rootEl.getAttribute('data-rendermode') !== undefined)
                renderMode = rootEl.getAttribute('data-rendermode');

            if (rootEl.getAttribute('data-submitmode') !== null && rootEl.getAttribute('data-submitmode') !== undefined)
                submitMode = rootEl.getAttribute('data-submitmode');

            if (rootEl.getAttribute('data-selected-size') !== null && rootEl.getAttribute('data-selected-size') !== undefined)
                designerSelectedSize = rootEl.getAttribute('data-selected-size');

            if (rootEl.getAttribute('data-selected-color') !== null && rootEl.getAttribute('data-selected-color') !== undefined)
                designerSelectedColor = rootEl.getAttribute('data-selected-color');

            if (rootEl.getAttribute('data-exportperspective') !== null && rootEl.getAttribute('data-exportperspective') !== undefined)
                exportPerspective = rootEl.getAttribute('data-exportperspective');

            if (rootEl.getAttribute('data-exportborder') !== null && rootEl.getAttribute('data-exportborder') !== undefined)
                exportBorder = (rootEl.getAttribute('data-exportborder') == "1");

            if (rootEl.getAttribute('data-isaddonmode') !== null && rootEl.getAttribute('data-isaddonmode') !== undefined)
                isDesignerAddonMode = (rootEl.getAttribute('data-isaddonmode') == "1");

            if (rootEl.getAttribute('data-designerdebug') !== null && rootEl.getAttribute('data-designerdebug') !== undefined)
                showDebug = (rootEl.getAttribute('data-designerdebug') == "1");

            if (renderMode == 'exportresult' && rootEl.getAttribute('data-exportscaling') !== null && rootEl.getAttribute('data-exportscaling') !== undefined)
                exportScaling = parseFloat(rootEl.getAttribute('data-exportscaling'));

            if (rootEl.getAttribute('data-configjson') !== null && rootEl.getAttribute('data-configjson') !== undefined)
            {
                designerLoadedDesign = JSON.parse(rootEl.getAttribute('data-configjson'));
                if (designerLoadedDesign.designerMode !== null)
                {
                    designerMode = designerLoadedDesign.designerMode;
                }
            }

            if (rootEl.getAttribute('data-designer-loaded-callback') !== null && rootEl.getAttribute('data-designer-loaded-callback') !== undefined)
                designerLoadedCallback = rootEl.getAttribute('data-designer-loaded-callback');

            const designerInitConfig = {
                designerConfigInterfaceUrl: designerConfigInterfaceUrl,
                designerHasComplex: designerHasComplex,
                designerHasSimple: designerHasSimple,
                designerArticleId: designerArticleId,
                designerLoadedDesign: designerLoadedDesign,
                designerMode: designerMode,
                renderMode: renderMode,
                submitMode: submitMode,
                exportScaling: exportScaling,
                exportPerspective: exportPerspective,
                exportBorder: exportBorder,
                showDebug: showDebug,
                designerLoadedCallback: designerLoadedCallback,
                designerSelectedColor: designerSelectedColor,
                designerSelectedSize: designerSelectedSize,
                isDesignerAddonMode: isDesignerAddonMode,
                addonArticleName: addonArticleName,
                addonBasketArticleId: addonBasketArticleId
            };


            ReactDOM.render(<App designerInitConfig={designerInitConfig} />, rootEl);
        }
    }
});




// WEBPACK FOOTER //
// ./src/index.js